/// <amd-module name="Agile/Common/Redux/TeamSettings/TeamSettingsSagas" />
import { TeamSettingsActionsCreator } from "Agile/Common/Redux/TeamSettings/TeamSettingsActions";
import { getUtcDate } from "Agile/Common/Utils/Date";
import { ITeamSettings } from "Agile/Contracts/Common";
import { effects, SagaIterator } from "redux-saga";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export function* loadTeamSettings(): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const contributionService: IVssContributionService = (yield effects.call(
        [pageContext, pageContext.getService],
        "IVssContributionService"
    )) as any;
    const teamSettings: ITeamSettings = (yield effects.call(
        [contributionService, contributionService.getData],
        "ms.vss-work-web.team-wit-settings-data-provider"
    )) as any;

    // TODO: Team settings load error experience #1424385

    const allIterations = [
        ...(teamSettings.currentIteration ? [teamSettings.currentIteration] : []),
        ...(teamSettings.futureIterations || []),
        ...(teamSettings.previousIterations || [])
    ];
    // Shift iteration start/end date
    allIterations.forEach(itr => {
        if (itr.startDate) {
            itr.startDate = getUtcDate(itr.startDate);
        }
        if (itr.finishDate) {
            itr.finishDate = getUtcDate(itr.finishDate);
        }
    });
    yield effects.put(TeamSettingsActionsCreator.teamSettingsLoaded(teamSettings));
}
